<template>
  <pipeline-layout>
    <!--Main Content-->
    <table-paginated
      ref="nonLeadPipelineTable"
      :load-data="loadNonLeadRecords"
      :columns="columns"
      :per-page="50"
      :actions-width="100"
      empty-heading="No non leads"
      is-empty-boxed
      entries-label="leads"
    >
      <template #emptyMessage>This is where the leads created by spam calls or website submissions will reside.  You can control the lead statuses that show here in the <router-link :to="{name: 'settings', params: {tab: 'pipeline'}}">Pipeline Settings</router-link>. If you'd like to see these reporting in the stats and reports sections of Forefront, keep them here.  If you have test leads you don't want to show up in the stats, delete them.</template>

      <template v-slot:actions="items">
        <button-link @click="openRecordModal(items.row.id)">View</button-link>
      </template>
    </table-paginated>

    <!--Filters-->
    <template #filters>
      <non-lead-filters :refresh="refresh"></non-lead-filters>
    </template>
  </pipeline-layout>
</template>

<script>
import TablePaginated from "../../../../components/table/TablePaginated";
import PipelineLayout from "../../components/PipelineLayout";
import NonLeadFilters from "./components/NonLeadFilters";
import api from "../../../../api";
import dates from "../../../../services/dates";
import router from "../../../../router";

export default {
  name: "NonLeadPipelineDesktop",
  components: {NonLeadFilters, PipelineLayout, TablePaginated},
  data() {
    const that = this;
    return {
      columns: [
        {
          label: "Status",
          display(row) {
            return that.getStatusLabel(row.current_status_id);
          }
        },
        {
          label: "Address",
          display(row) {
            return row.property.line_1;
          },
          isSensitiveDate: true,
        },
        {
          label: "City",
          display(row) {
            return row.property.city;
          },
          isSensitiveDate: true,
        },
        {
          label: "State",
          display(row) {
            return row.property.state;
          },
          isSensitiveDate: true,
        },
        {
          label: "Campaign",
          display(row) {
            return that.getCampaignLabel(row.campaign_id);
          }
        },
        {
          label: "Non Lead At",
          display(row) {
            // return that.formatDate(row.non_lead_at);
            return that.formatDate(row.entered_status_at);
          }
        },
      ],
    };
  },
  computed: {
    filters() {
      return this.$store.getters["nonLeadState/filters"];
    }
  },
  methods: {
    openRecordModal(recordId) {
      router.replace({query: {lead: recordId}});
    },
    loadNonLeadRecords(query = "") {
      const queryString = `status=${this.filters.statuses}&campaign=${this.filters.campaigns}&source=${this.filters.sources}&${query}`;
      return api.records.getPipelineNonLeadRecords(queryString);
    },
    refresh() {
      if (this.$refs.nonLeadPipelineTable) {
        return this.$refs.nonLeadPipelineTable.queryData();
      }
    },
    getCampaignLabel(campaignId) {
      let campaign = this.$store.getters.campaigns.find(campaign => campaign.id === campaignId);
      return campaign ? campaign.label : null;
    },
    getStatusLabel(statusId) {
      let status = this.$store.getters['pipeline/nonLeadStatuses'].find(status => status.id === statusId);
      return status ? status.label : null;
    },
    formatDate(date) {
      return dates.formatAsDate(date);
    },
  },
}
</script>
